export default {
    poweredBy: "Alimenté par"
}